const rankingItems = [
  { rank: 1, title: '顶流男星私密视频外泄，团队连夜发律师函全网删帖', heat: '987万', trend: 'up', change: '+320%' },
  { rank: 2, title: '某女星被拍到与已婚富商同游海外，助理称只是工作', heat: '856万', trend: 'up', change: '+256%' },
  { rank: 3, title: '知名综艺节目剪辑恶意丑化嘉宾，当事人发文怒斥节目组', heat: '742万', trend: 'up', change: '+189%' },
  { rank: 4, title: '某选秀冠军被曝学历造假，母校回应正在核查相关材料', heat: '631万', trend: 'same', change: '持平' },
  { rank: 5, title: '热门网剧男二号涉毒被警方带走，剧组紧急换角重拍', heat: '528万', trend: 'up', change: '+145%' },
  { rank: 6, title: '两位一线女星因番位问题在颁奖礼后台互撕，视频疯传', heat: '419万', trend: 'down', change: '-12%' },
  { rank: 7, title: '某知名导演被多名女演员实名举报性骚扰，行业震动', heat: '387万', trend: 'up', change: '+98%' },
];

export default function SectionRanking() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">吃瓜热度榜</h2>
          <span className="text-xs bg-accent-100 text-accent-700 px-2 py-0.5 rounded-full font-semibold whitespace-nowrap">TOP 7</span>
        </div>
        <p className="text-sm text-foreground-600 mb-8 md:mb-10 pl-4">实时追踪全网热度，17c与51吃瓜同步更新，吃瓜群众最关注的明星黑料与娱乐圈八卦排名</p>

        <div className="space-y-3">
          {rankingItems.map((item) => (
            <a
              key={item.rank}
              href="#"
              onClick={(e) => e.preventDefault()}
              className="flex items-center gap-4 md:gap-5 bg-background-100 hover:bg-primary-50/50 rounded-lg p-4 md:p-5 transition-colors border border-background-200/70 cursor-pointer group"
            >
              <div
                className={`shrink-0 w-10 h-10 md:w-11 md:h-11 rounded-lg flex items-center justify-center font-heading text-lg md:text-xl font-bold ${
                  item.rank === 1
                    ? 'bg-accent-500 text-white'
                    : item.rank === 2
                    ? 'bg-accent-300 text-accent-900'
                    : item.rank === 3
                    ? 'bg-accent-200 text-accent-800'
                    : 'bg-background-200 text-foreground-600'
                }`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {item.title}
                </h3>
              </div>
              <div className="shrink-0 flex items-center gap-2 md:gap-3">
                <span className="text-xs md:text-sm font-semibold text-accent-600 whitespace-nowrap">{item.heat}热度</span>
                <span
                  className={`text-xs whitespace-nowrap ${
                    item.trend === 'up'
                      ? 'text-primary-600'
                      : item.trend === 'down'
                      ? 'text-foreground-400'
                      : 'text-foreground-500'
                  }`}
                >
                  {item.trend === 'up' && <i className="ri-arrow-up-line mr-0.5"></i>}
                  {item.trend === 'down' && <i className="ri-arrow-down-line mr-0.5"></i>}
                  {item.trend === 'same' && <i className="ri-subtract-line mr-0.5"></i>}
                  {item.change}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}